import { Box, styled } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FormattedMessage } from "react-intl";

const DashedButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1),
  width: "100%",
  padding: theme.spacing(1.5),
  border: `1.5px dashed ${theme.palette.divider}`,
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  fontSize: "0.8rem",
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "inherit",
  "&:hover": {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
}));

interface Props {
  count: number;
  onClick: () => void;
}

export const LoadOlderButton: FC<Props> = ({ count, onClick }) => (
  <Box mt={1}>
    <DashedButton
      type="button"
      onClick={onClick}
      data-testid="load-older-invoices"
    >
      <ExpandMoreIcon fontSize="small" />
      <FormattedMessage
        id="invoicing.v2.loadOlder"
        defaultMessage="Load older invoices ({count})"
        values={{ count }}
      />
    </DashedButton>
  </Box>
);
